import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "3xl:justify-between mx-[6%] flex flex-col-reverse items-center justify-evenly lg:flex-row" }
const _hoisted_2 = { class: "mt-8 flex w-full flex-col flex-nowrap content-center items-center justify-center space-y-4 font-semibold md:w-auto md:flex-row md:space-x-4 md:space-y-0 lg:mt-4 lg:flex-col lg:space-x-0 lg:space-y-4 lg:text-center xl:flex-row xl:space-x-4 xl:space-y-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "founder-image size-24 rounded-full bg-cover lg:size-40" }, null, -1)
const _hoisted_4 = { class: "text-center lg:ml-0" }
const _hoisted_5 = { class: "mt-0.5 text-sm leading-6 text-slate-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block = _resolveComponent("block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.role), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_block, {
        class: "mx-[1%] max-w-3xl text-justify lg:text-left",
        value: _ctx.quote
      }, null, 8, ["value"])
    ])
  ]))
}